import { NgModule, NO_ERRORS_SCHEMA } from '@angular/core';

import { ChangeAccountingComponent } from './admin-dashboard.change-accounting.component';
import { AdminDashboardService }     from './admin-dashboard.service';
import { SharedModule }              from '../shared/shared.module';
import { TableModule }               from '../table/table.module';

@NgModule({
  declarations: [
    ChangeAccountingComponent
  ],
  entryComponents: [
    ChangeAccountingComponent
  ],
  exports: [
    ChangeAccountingComponent
  ],
  imports: [
    SharedModule,
    TableModule,
  ],
  providers: [
    AdminDashboardService
  ],
  schemas: [NO_ERRORS_SCHEMA],
})
export class AdminDashboardModule {}